import React from 'react';
import { motion } from 'framer-motion';

const galleryImages = [
  {
    url: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Pizza margherita artigianale',
  },
  {
    url: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Pasta fresca al ragù',
  },
  {
    url: 'https://customer-assets-jai6qajn.emergentagent.net/job_rovescio-reserve/artifacts/4mklddgw_foto%20rovescio.jpeg',
    alt: 'Insalata di salmone con avocado e mandorle',
  },
  {
    url: 'https://customer-assets-jai6qajn.emergentagent.net/job_rovescio-reserve/artifacts/qlp4e61h_foto%20rovescio%202.jpeg',
    alt: 'Tagliere di salumi e formaggi con vino',
  },
];

const Gallery = () => {
  return (
    <section id="gallery" className="section-padding bg-[#1A1A1A] relative" data-testid="gallery-section">
      <div className="art-deco-pattern" />
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[#FFDA00] mb-4 font-semibold">
            Galleria
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="gallery-title"
          >
            Momenti da Rovèscio
          </h2>
          <p className="text-gray-300 text-lg">Atmosfera, piatti e dettagli che raccontano la nostra storia</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {galleryImages.map((image, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="relative overflow-hidden group cursor-pointer"
              style={{ height: '300px' }}
              data-testid={`gallery-image-${idx}`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#222222]/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
